import './switch.css';

/**
 * Interruptor de efeito imediato.
 *
 * `aria-label` é obrigatório e precisa nomear O QUE é ligado, não a ação:
 * "Agente Triagem" e não "Ligar agente". O leitor já anuncia o estado
 * ("ativado"/"desativado") a partir de `aria-checked`; um rótulo com verbo faz
 * o anúncio virar "ligar agente, ativado", que se contradiz.
 */
export function Switch({
  checked, onChange, label, estadoTexto, disabled, motivo,
}: {
  checked: boolean;
  onChange: (valor: boolean) => void;
  label: string;
  /** Texto visível ao lado. Omita quando o contexto já disser. */
  estadoTexto?: { ligado: string; desligado: string };
  disabled?: boolean;
  /** Por que está desabilitado. Vira o nome acessível junto do rótulo. */
  motivo?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      className="switch"
      aria-checked={checked}
      aria-label={motivo ? `${label} — ${motivo}` : label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="switch__trilho" aria-hidden="true">
        <span className="switch__botao" />
      </span>
      {estadoTexto && (
        <span className="switch__estado">{checked ? estadoTexto.ligado : estadoTexto.desligado}</span>
      )}
    </button>
  );
}
